import { ReactNode } from "react";
import { cn } from "../../lib/utils";

const SectionHeadline = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => {
  return (
    <h2 className={cn("font-aracne text-[#000000] uppercase text-[28px] md:text-[40px]")}>
      <span className={cn("bg-white px-4", className)}>{children}</span>
    </h2>
  );
};

export default SectionHeadline;
